import { cn } from '@cobliteam/ui/utils';
import type React from 'react';
import { DraggableListProvider } from '../context/DraggableListContext';
import { useDraggableList } from '../hooks/useDraggableList';

export interface DraggableListContainerProps {
  children: React.ReactNode;
  className?: string;
}

const DraggableListContainer = ({ children, className }: DraggableListContainerProps) => {
  const { scrollerRef, onScroll, onDrag, onDragStart, onDragEnd } = useDraggableList();

  return (
    <DraggableListProvider value={{ onDrag, onDragStart, onDragEnd }}>
      <div className={cn('overflow-y-auto', className)} ref={scrollerRef} onScroll={onScroll}>
        {children}
      </div>
    </DraggableListProvider>
  );
};

export default DraggableListContainer;
